import moment from 'moment';

export const formatDateString = (
	date: string,
	format = 'DD/MM/yyyy',
	isLocal = true,
): string => isLocal ? moment.utc(date).local().format(format) : moment(date).format(format);
